import { apiEndpoints } from '@/apiEndpoints';
import { SupportedLocale } from '@/types/supported-locale.type';
import axios from 'axios';

type TranslateTextResponse = {
  text: string;
  detectedSourceLang: string;
  billedCharacters: number;
  modelTypeUsed?: string;
};

export const translateText = async (
  text: string,
  language: SupportedLocale,
  sourceLanguage?: SupportedLocale,
) => {
  const response = await axios.post<TranslateTextResponse>(
    apiEndpoints.translation.translate,
    {
      text,
    },
    { params: { language, sourceLanguage } },
  );
  return response.data;
};

export const translateTexts = async (
  texts: string[],
  language: SupportedLocale,
  sourceLanguage?: SupportedLocale,
) => {
  const response = await axios.post<TranslateTextResponse[]>(
    apiEndpoints.translation.translateMany,
    { texts },
    { params: { language, sourceLanguage } },
  );
  return response.data;
};
